import React from 'react';
import { IDataSource, IJoinField } from '@types';
import { Button, IconButton, Input, Select } from 'uxp/components';
import './FieldMapper.scss';

interface FieldMapperProps {
    fields: IJoinField[],
    source: IDataSource,
    onChange: (conditions: IJoinField[]) => void;
    disableRename?: boolean
}

export const FieldMapper: React.FC<FieldMapperProps> = ({ fields, source, onChange, disableRename }) => {

    const updateField = (index: number, field: keyof (IJoinField), value: string) => {
        const newFields = [...fields];
        newFields[index] = { ...newFields[index], [field]: value }
        onChange(newFields);
    };

    const addField = () => {
        const newFields = [...fields, { field: '', newField: '' }];
        onChange(newFields);
    };

    const removeField = (index: number) => {
        const newFields = fields.filter((_, i) => i !== index);
        onChange(newFields);
    };

    return (
        <div className="lucy-query-engine-source-mapper">
            {
                (fields || []).map((c, i) => (
                    <div key={i} className="lucy-query-engine-source-mapper-condition">
                        <div className="lucy-query-engine-source-mapper-condition-field">
                            <Select
                                selected={c.field}
                                onChange={s => updateField(i, 'field', s)}
                                options={(source?.schema || []).map(f => ({ label: f.name, value: f.name }))}
                            />
                        </div>
                        {
                            !disableRename ?
                                <div className="lucy-query-engine-source-mapper-condition-field">
                                    <Input value={c.newField} onChange={(txt) => updateField(i, 'newField', txt)} />

                                </div>
                                : null
                        }
                        <IconButton type='delete' onClick={() => removeField(i)} size='small' />
                    </div>
                ))
            }

            <div className="lucy-query-engine-source-mapper-condition">
                <Button title='Add field' onClick={addField} icon='fas plus' />
            </div>
        </div>
    );
};
